import type { ReactNode } from "react";
import { isNativeApp } from "@/platform";

export type ContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  disableBottomSafeArea?: boolean;
  /**
   * A page whose job is to be read — a transcript, a summary, a translation.
   * Turns the canvas down to a calm wash so long copy is not competing with
   * the colour field. Everything else keeps the full field.
   */
  reading?: boolean;
};

const Container = ({
  children,
  className = "",
  disableBottomSafeArea = false,
  reading = false,
  style,
  ...props
}: ContainerProps) => {
  const native = isNativeApp();
  return (
    <div
      className={`app-page-background ${reading ? "app-reading-background" : ""} ${className}`}
      style={{
        ...(native
          ? {
              paddingTop: "env(safe-area-inset-top)",
              paddingBottom: disableBottomSafeArea
                ? 0
                : "env(safe-area-inset-bottom)",
            }
          : {}),
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
};

export default Container;
